/**
 * Lines for the signed-in user dropdown header. When name and email are the
 * same (e.g. DB seed or legacy rows), only the email line should show to
 * avoid a duplicate display.
 */
export function getUserMenuHeaderLines(userData, hasUserData) {
  if (!hasUserData) {
    return { showNameRow: false, displayName: 'User', displayEmail: 'user@example.com' };
  }
  const email = (userData?.email || '').trim();
  const name = (userData?.name || '').trim();
  if (!email) {
    return {
      showNameRow: name.length > 0,
      displayName: name || 'User',
      displayEmail: 'user@example.com',
    };
  }
  const sameAsEmail = !name || name.toLowerCase() === email.toLowerCase();
  return {
    showNameRow: !sameAsEmail,
    displayName: name || 'User',
    displayEmail: email,
  };
}
